/**
 * Admin "Placement Background Image" URL from the placement payload
 * (placement.background_image_url). Only absolute http(s) or root-relative
 * .png / .jpg / .jpeg URLs without quotes, parentheses, backslashes, angle
 * brackets or whitespace are used, so the value is safe inside CSS url("…").
 */
var PLACEMENT_BACKGROUND_URL_PATTERN = /^(https?:\/\/[^\s"'()\\<>]+|\/[^/\s"'()\\<>][^\s"'()\\<>]*)\.(png|jpe?g)$/i;

var PLACEMENT_BACKGROUND_URL_MAX_LENGTH = 500;

export function placementBackgroundUrl(placement) {
  var value = placement && placement.background_image_url;
  if (typeof value !== "string") return null;
  value = value.trim();
  if (!value || value.length > PLACEMENT_BACKGROUND_URL_MAX_LENGTH) return null;
  return PLACEMENT_BACKGROUND_URL_PATTERN.test(value) ? value : null;
}
